import Nav from "@/components/Nav";
import Mission from "@/components/Mission";
import Footer from "@/components/Footer";

export default function LabPage() {
  return (
    <>
      <Nav />
      <main>
        <Mission />
      </main>
      <Footer />
    </>
  );
}
